import { Button } from '@components/ui/button';
import { buildNovartisContactFormUrl, cn, isNovartisInstance, trimQuery } from '@lib/utils';
import { useTranslation } from 'react-i18next';

interface INovartisContactFormButtonProps {
  align?: 'left' | 'center';
  query?: string;
}

function NovartisContactFormButton(props: INovartisContactFormButtonProps) {
  const { t } = useTranslation();
  const query = trimQuery(props.query || '');

  if (!isNovartisInstance() || !query) {
    return null;
  }

  return (
    <div className={cn('mt-4 flex', props.align === 'center' ? 'justify-center' : 'justify-start')}>
      <Button
        asChild
        className="bg-xircle-secondary follow-up-buttons hover:bg-xircle-secondary/90"
      >
        <a
          className="no-underline hover:no-underline"
          href={buildNovartisContactFormUrl(query)}
          target="_blank"
          rel="noreferrer"
        >
          {t('chat.medical_info.prefill_contact_form')}
        </a>
      </Button>
    </div>
  );
}

export default NovartisContactFormButton;
